import { render, staticRenderFns } from "./nutritionist-detail.vue?vue&type=template&id=4f29a5b5&scoped=true&"
import script from "./nutritionist-detail.vue?vue&type=script&lang=js&"
export * from "./nutritionist-detail.vue?vue&type=script&lang=js&"
import style0 from "./nutritionist-detail.vue?vue&type=style&index=0&id=4f29a5b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f29a5b5",
  null
  
)

export default component.exports